import {
  HasTenantResource,
  ResourceConfig,
  ResourceSystemFields,
  SearchFilterConfig,
} from '@hidat/huijs-resource';
import { FieldConfig, FieldDataTypes, nNumber } from '@hidat/huijs-common';
import { LocalDate } from '@js-joda/core';
import { SplixerResourceInterface } from './splixer-resource.interface';

// Should this be renamed to 'Timeslot'???

export const ScheduleConfig = new ResourceConfig('Schedule')
  .addField(ResourceSystemFields.status)
  .addFields([
    new FieldConfig('stationId', FieldDataTypes.NUMBER),
    new FieldConfig('channelId', FieldDataTypes.NUMBER),
    new FieldConfig('startsAt', FieldDataTypes.DATE),
    new FieldConfig('endsAt', FieldDataTypes.DATE),
    new FieldConfig('monday', FieldDataTypes.UNKNOWN).setEditable(false),
    new FieldConfig('tuesday', FieldDataTypes.UNKNOWN).setEditable(false),
    new FieldConfig('wednesday', FieldDataTypes.UNKNOWN).setEditable(false),
    new FieldConfig('thursday', FieldDataTypes.UNKNOWN).setEditable(false),
    new FieldConfig('friday', FieldDataTypes.UNKNOWN).setEditable(false),
    new FieldConfig('saturday', FieldDataTypes.UNKNOWN).setEditable(false),
    new FieldConfig('sunday', FieldDataTypes.UNKNOWN).setEditable(false),
  ]);

export const ScheduleIncludes = {
  station: 'station',
};

export const ScheduleFilterConfig = new SearchFilterConfig(ScheduleConfig, {
  only: ['stationId', 'startsAt', 'status'],
});

export interface ScheduleInterface
  extends SplixerResourceInterface<number>, HasTenantResource {
  stationId: number | undefined;
  channelId: number | undefined;
  // Station Time
  startsAt: LocalDate | undefined;
  endsAt: LocalDate | undefined | null;
  // 24 program ID's
  monday: nNumber[] | undefined;
  tuesday: nNumber[] | undefined;
  wednesday: nNumber[] | undefined;
  thursday: nNumber[] | undefined;
  friday: nNumber[] | undefined;
  saturday: nNumber[] | undefined;
  sunday: nNumber[] | undefined;
}
